module.exports = __webpack_public_path__ + "static/img/case_tab_06.fe5afe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_06.png
// module id = dOVo
// module chunks = 34